import { Component, OnInit, OnDestroy } from '@angular/core';
import { Message } from 'primeng/primeng';
import { NotificationsService } from './notifications.service';
import { Subscription } from 'rxjs/Subscription';

@Component({
  selector: 'app-notifications',
  template: `  <p-growl [sticky]="false" [life]="5000" [value]="growl"></p-growl>
               <p-messages [value]="message"></p-messages>`,  
})
export class NotificationsComponent implements OnInit, OnDestroy {
  growl: Message[] = [];
  message: Message[] = [];
  growlSubscription: Subscription;
  messageSubscription: Subscription;

  constructor(private notificationsService: NotificationsService) { 
    console.log('construct notif component'); 

  }

  ngOnInit() {
    this.subscribeToGrowlNotifications();
    this.subscribeToMessageNotifications();
  }

  subscribeToGrowlNotifications() {

    this.growlSubscription = this.notificationsService.growlNotificationChange
      .subscribe(notification => {
        this.growl = [notification];
        

      });
  }

  subscribeToMessageNotifications() {
    this.messageSubscription = this.notificationsService.messageNotificationChange
      .subscribe(( notification: Message[])  => {
 /*       this.message.length = 0;
        if ( notification !== undefined) {
          notification.forEach(element => {
            this.message.push(element);
          });
        }
    */  });
  }

  ngOnDestroy() {
    console.log('ngDestroy');
    this.growlSubscription.unsubscribe();
    this.messageSubscription.unsubscribe();
  }
}